import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoNoTributarioDetService {
  constructor(private gqlclient: GraphQLClient) { }

  obtenerSegunFiltro(
    inputParams: {
      rut_empresa: number;
      folio: number;
      tipo_dte_codigo: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_empresa: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento_no_tributario_det {
              obtenerSegunFiltro(
                filtro: { exacto: { rut_empresa: $rut_empresa, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    cantidad
                    cantidad_atendida
                    descuento
                    linea
                    precio_neto
                    precio_unitario
                    monto_iva
                    monto_total
                    descuento
                    nombreFormato
                    nombreProducto
                    skuProducto
                    estadoAtendido
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario_det.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerFiltroNotaVenta(
    inputParams: {
      estado: Array<any>;
      vendedor: Array<any>;
      comuna: Array<any>;
      filtro: {
        exacto: {
          fecha_desde: Date;
          fecha_hasta: Date;
          rut_empresa: number;
          folio: number;
          folio_fact: number;
        };
      };
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query (
            $filtro: FiltroInputTypeOfdocumento_no_tributarioTOdocumento_no_tributarioInputType
            $estado: [Decimal]
            $vendedor: [Decimal]
            $comuna: [Decimal]
            $clientes: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            documento_no_tributario {
              obtenerFiltroNotaVenta(filtro: $filtro, estado: $estado, vendedor: $vendedor, comuna: $comuna, clientes: $clientes, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    vendedor_nombre
                    folio
                    fecha_emision
                    direccion_cliente_rut
                    nombrecliente
                    vendedor_nombre
                    comuna
                    total_neto
                    total_bruto
                    estado_documento_codigo
                    estado_documento_nombre
                    origen
                    folio_referencia
                    direccion_codigo
                    folio_factura
                    observacion_2
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_no_tributario.obtenerFiltroNotaVenta;
        callback({ mensajes, respuesta });
      }
    );
  }
}
